import React, { ReactNode, useRef } from 'react';
import { MessageThreadModel } from '../models/MessageThreadModel';
import { formatDate } from '../utils/dateUtils';



interface MessageThreadListProps {
    messageThreads: MessageThreadModel[];
    selectedThread: MessageThreadModel | null;
    filter: 'all' | 'read' | 'unread';
    handleThreadClick: (thread: MessageThreadModel) => void;
    handleFilterChange: (filter: 'all' | 'read' | 'unread') => void;
    children?: ReactNode;
}

const MessageThreadListComp: React.FC<MessageThreadListProps> = ({
    messageThreads,
    selectedThread,
    filter,
    handleThreadClick,
    handleFilterChange,
    children
}) => {
    const bottomRef = useRef<HTMLLIElement | null>(null);
    return (
        <div className="d-flex flex-column w-100 h-100">
            <div
                className="btn-group mb-1 me-1"
                role="group"
                aria-label="Message filter buttons"
                style={{ marginLeft: '1px' }}
            >
                <input
                    type="radio"
                    className="btn-check"
                    name="btnradio"
                    id="btnRadioAll"
                    autoComplete="off"
                    checked={filter === 'all'}
                    onChange={() => handleFilterChange('all')}
                />
                <label className="btn btn-outline-dark btn-sm rounded-0" htmlFor="btnRadioAll" style={{ outline: 'none', boxShadow: 'none' }}>
                    All
                </label>

                <input
                    type="radio"
                    className="btn-check"
                    name="btnradio"
                    id="btnRadioRead"
                    autoComplete="off"
                    checked={filter === 'read'}
                    onChange={() => handleFilterChange('read')}
                />
                <label className="btn btn-outline-dark btn-sm rounded-0" htmlFor="btnRadioRead" style={{ outline: 'none', boxShadow: 'none' }}>
                    Read
                </label>

                <input
                    type="radio"
                    className="btn-check"
                    name="btnradio"
                    id="btnRadioUnread"
                    autoComplete="off"
                    checked={filter === 'unread'}
                    onChange={() => handleFilterChange('unread')}
                />
                <label className="btn btn-outline-dark btn-sm rounded-0" htmlFor="btnRadioUnread" style={{ outline: 'none', boxShadow: 'none' }}>
                    Unread
                </label>
            </div>

            <ul className="border mb-0 me-1 list-group rounded-0" style={{ overflowY: 'auto', flex: 1 }}>
                {messageThreads.length === 0 ? (
                    <li className="d-flex flex-column justify-content-center align-items-center text-muted" style={{ height: '150px' }}>
                        <i className="bi bi-chat-dots fs-2 mb-2"></i>
                        <span>No messages available.</span>
                    </li>
                ) : (
                    messageThreads.map((thread) => (
                        <li
                            key={thread.messageThreadId}
                            className={`list-group-item border-top-0 border-end-0 border-start-0 border-bottom ${selectedThread?.messageThreadId === thread.messageThreadId ? 'active' : ''
                                } rounded-0`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleThreadClick(thread)}
                        >
                            <div className={`${thread.sellerUnread ? 'fw-bold' : 'fw-normal'} text-truncate`}>
                                {thread.subject}
                            </div>
                            {thread.lastMessage && (
                                <div className="text-muted small text-truncate">
                                    {thread.lastMessage.messageContent}
                                </div>
                            )}
                            <div className="text-muted small">{formatDate(thread.lastUpdatedTime)}</div>
                        </li>
                    ))
                )}

                {children}
            </ul>
        </div>
    );
};

export default MessageThreadListComp;
